<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :is-show-apply-state-select="true"
    apply-state-select-label="审核状态"
    :is-show-add-administrator-select="isAdministrator"
    add-administrator-select-label="申请人"
    :is-show-update-administrator-select="isAdministrator"
    update-administrator-select-label="审核人"
    :is-show-student-select="true"
    student-select-label="被修改学员"
    :push-list="RouteConfig.studentUpdateRequestList.push"
    :query-list="queryList"
  >
    <v-column-time value="申请时间"/>

    <v-column-avatar label="申请人员" avatar-key="add_administrator_avatar" nickname-key="add_administrator_nickname"/>

    <el-table-column label="申请门店" prop="store_name"/>

    <el-table-column label="申请操作" align="center">
      <template v-slot="{ row }">
        <template v-for="updateType in findStudentUpdateType(row.update_type)">
          修改{{ updateType.name }}
        </template>
      </template>
    </el-table-column>

    <v-column-student label="被修改学员" link-page-id="student_id"/>

    <el-table-column label="学员 ID" prop="student_id" align="center"/>

    <el-table-column label="修改原因" prop="reason"/>

    <el-table-column label="原因截图">
      <template v-slot="{ row }">
        <v-img v-if="row.reason_img" class="table-cover-phone" :value="row.reason_img"/>
        <span v-else class="info-color">未上传</span>
      </template>
    </el-table-column>

    <el-table-column label="审核状态">
      <template v-slot="{ row }">
        <div v-for="state in findApplyState(row.apply_state)" :key="state.value">
          <el-tag :type="state.tagType">{{ state.name }}</el-tag>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="操作">
      <template v-slot="{ row }">
        <v-list-button name="查看" icon="view" :to="RouteConfig.studentUpdateRequestDetail.to(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`apply-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-title border-bottom">
              <span>{{ v.add_time | timeToYmdHi }}</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="divider"></div>
            <div class="list-item-detail">
              <span>申请人员</span>
              <span>{{ v.add_administrator_nickname }}</span>
            </div>
            <div class="list-item-detail">
              <span>申请操作</span>
              <template v-for="updateType in findStudentUpdateType(v.update_type)">
                修改{{ updateType.name }}
              </template>
            </div>
            <div class="list-item-detail">
              <span>被修改学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>学员 ID</span>
              <span>{{ v.student_id }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改原因</span>
              <span v-if="v.reason">{{ v.reason }}</span>
              <span v-else class="info-color">未填写</span>
            </div>
            <div class="list-item-detail">
              <span>审核状态</span>
              <div v-for="state in findApplyState(v.apply_state)" :key="state.value">
                <el-tag :type="state.tagType">{{ state.name }}</el-tag>
              </div>
            </div>
            <div class="list-item-button">
              <v-list-button name="查看" icon="view" :to="RouteConfig.studentUpdateRequestDetail.to(v.id)"/>
            </div>
          </div>

        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>

  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { studentUpdateTypes, findStudentUpdateType } from '@/enums/studentUpdateTypes';
import { index } from '@/api/student-update-request';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.studentUpdateRequestList.name,
  data: () => ({
    RouteConfig,
    applyStates,
    studentUpdateTypes,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      apply_states: [applyStates.review.value],
      page: 1,
      size: 8,
    },
    isLoading: false,
    isRevokingIds: [],
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findStudentUpdateType,
    findApplyState,
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
